import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateDisplayConfig = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Display Config'
      fields={fields}
      apiPath='admin/display_configs'
      successRedirectPath={resource => `/write-now/display_configs/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateDisplayConfig
